import { LoadingButton } from "@mui/lab";
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useUpdateHobbiesMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

export const PROFILE_HOBBIES_OPTIONS = [
  "travel",
  "photography",
  "sports",
  "books",
  "art/theatre/films",
  "music",
  "social impact",
  "art & culture",
  "poker",
  "board games",
  "food & cooking",
  "cocktails & wine",
];

function EditHobbies({ hobbies, onClose }: any) {
  const [chosenValues, setChosenValues] = useState<string[]>(
    hobbies.filter((eachHobby: string) =>
      PROFILE_HOBBIES_OPTIONS.includes(eachHobby)
    )
  );

  const [updateHobbies, { isLoading: isUpdateHobbiesLoading }] =
    useUpdateHobbiesMutation();

  const { enqueueSnackbar } = useSnackbar();

  const onUpdateHandler = async () => {
    try {
      if (!chosenValues.length) {
        return enqueueSnackbar("please select atleast one hobby", {
          variant: "error",
        });
      }
      await updateHobbies(chosenValues).unwrap();
      enqueueSnackbar("updated your hobbies", {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("failed to update your hobbies", {
        variant: "error",
      });
    }
  };

  const onTagPress = (tag: string) => {
    if (chosenValues?.find((id) => id === tag)) {
      const newTags = chosenValues?.filter((id) => id !== tag);
      setChosenValues(newTags);
    } else {
      setChosenValues((prevValues) => [...prevValues, tag]);
    }
  };

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit hobbies</Typography>
      </CustomDialogTitle>
      <DialogContent dividers>
        <Stack direction="row" flexWrap="wrap">
          {PROFILE_HOBBIES_OPTIONS.map((tag) => {
            return (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant={
                  chosenValues?.find((id) => id === tag) ? "filled" : "outlined"
                }
                color={
                  chosenValues?.find((id) => id === tag) === tag
                    ? "primary"
                    : "default"
                }
                sx={{ mr: 1, mb: 1.5, fontSize: 12, pl: 1.5, pr: 1.5 }}
                onClick={() => onTagPress(tag)}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          cancel
        </Button>
        <LoadingButton
          variant="text"
          type="submit"
          loading={isUpdateHobbiesLoading}
          onClick={onUpdateHandler}
        >
          update
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default EditHobbies;
